import styled from '@emotion/styled';
import { HighlightImage } from './HighlightImage';
import { HighlightContent, IHighlightContentProps } from './HighlightContent';
import {
	ContentWrap,
	Css,
	ILinkItemType,
	IResponsiveImageSource,
	IStyledHighlightProps,
	ITheme,
	Responsive,
	StyledHighlight,
} from '../../../ui';

export interface IHighlight
	extends IStyledHighlightProps,
		IHighlightContentProps {
	id: string;
	imageSource?: IResponsiveImageSource;
	imageAlt?: string;
	linkType?: ILinkItemType;
}

export default function Highlight({
	id,
	orientation,
	imageSource,
	imageAlt,
	title,
	subtitle,
	body,
	linkHref,
	linkTitle,
	imagePosition,
	linkType,
}: IHighlight) {
	const isDesktopXL = Responsive.useMatchesBreakpoint('desktopXL');
	const Wrapper = isDesktopXL ? ContentWrap : 'section';

	return (
		<Wrapper id={id}>
			<StyledHighlightWrap
				orientation={orientation}
				imagePosition={imagePosition}
				withBackgroundColor
			>
				{imageSource && (
					<HighlightImageWrap>
						<HighlightImage
							source={imageSource}
							alt={imageAlt}
							isFirst={imagePosition && imagePosition[0] === 'first'}
						/>
					</HighlightImageWrap>
				)}

				<HighlightContent
					title={title}
					subtitle={subtitle}
					body={body}
					linkHref={linkHref}
					linkTitle={linkTitle}
					imagePosition={imagePosition}
					linkType={linkType}
				/>
			</StyledHighlightWrap>
		</Wrapper>
	);
}

const StyledHighlightWrap = styled(StyledHighlight)<
	{ imagePosition?: IHighlightContentProps['imagePosition'] },
	ITheme
>`
	display: flex;
	flex-direction: ${({ imagePosition }) =>
		imagePosition && imagePosition[0] === 'first' ? 'row' : 'row-reverse'};
	padding: ${Css.pxToRem(40)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-top: ${Css.pxToRem(10)};
		margin-bottom: ${Css.pxToRem(80)};
	}
`;

const HighlightImageWrap = styled.div`
	width: 55%;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;
